export default {"src":"https://js-static.hirist.tech/production/9.3.1/_next/static/media/man.3d535cfb.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};